import {Swiper, Autoplay, EffectCreative, Pagination} from 'swiper';

let mySwiper;


mySwiper = new Swiper('.testimonials-slider', {
    modules:[Autoplay, EffectCreative, Pagination],
    loop: false,
    effect: "creative",
    grabCursor: true,
    centeredSlides: true,
    slideToClickedSlide: true,
    slidesPerView: "auto",
    longSwipes: false,
    autoplay: {
        disableOnInteraction: true,
        delay: 7000,
    },
    breakpoints: {
        320: {
            creativeEffect: {
                prev: {
                    scale: 0.75,
                    translate: ["-18%", 0, 0],
                },
                next: {
                    scale: 0.75,
                    translate: ["18%", 0, 0],
                },
            },
        },
        767: {
            creativeEffect: {
                prev: {
                    scale: 0.75,
                    translate: ["-26%", 0, 0],
                },
                next: {
                    scale: 0.75,
                    translate: ["26%", 0, 0],
                },
            },
        }
    },
    pagination: {
        clickable: true,
        el: ".testimonials-pagination",
    },
});
